import PasswordField from "@/shared/components/form/Password";
import { useMutation } from "@apollo/client";
import { css } from "@emotion/react";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Field, Form } from "react-final-form";
import { connect, useDispatch } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "reactstrap";
import { LOG_IN_USER } from "../../../GraphQL/Mutation";
import renderCheckBoxField from "../form/CheckBox";
import { decryption, encryption } from "../../../containers/HelperFunctions";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { loginInfo } from "../../../utils/helpers";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import ReCAPTCHA from "react-google-recaptcha";

const encodeData = (data) => {
  return CryptoJS.AES.encrypt(data, "12345678").toString();
};

const decodeData = (encodedData) => {
  const bytes = CryptoJS.AES.decrypt(encodedData, "12345678");
  return bytes.toString(CryptoJS.enc.Utf8);
};
const LogInForm = ({
  errorMessage,
  errorMsg,
  fieldUser,
  typeFieldUser,
  form,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [resultCode, setResultCode] = useState("");
  const loggedInfo = loginInfo();
  const [loginUser, { data, loading, error }] = useMutation(LOG_IN_USER);

  // redirect if already logged user
  let { from } = location.state || { from: { pathname: "/" } };
  loggedInfo?.id && history.replace(from);

  const onSubmit = async (values) => {
    // if (!recaptchaValue) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "ReCAPTCHA Required",
    //     text: "Please complete the ReCAPTCHA verification.",
    //   });
    //   return;
    // }
    // console.log(values);
    const result = await loginUser({
      variables: {
        username: values.username,
        password: values.password,
      },
    });
    if (values.remember_me) {
      Cookies.set("username", encodeData(values.username), { expires: 7 });
      Cookies.set("password", encodeData(values.password), { expires: 7 });
      Cookies.set("remember_me", true, { expires: 7 });
    } else {
      Cookies.remove("username");
      Cookies.remove("password");
      Cookies.set("remember_me", false);
    }
  };

  if (resultCode) {
    alert(resultCode);
  }
  const token = data?.userLogin?.token;
  let permissions = [];
  let roles = [];
  data?.userLogin?.role?.map((role) => {
    roles.push(role?.role_name);
    role?.permissions?.map((permission) => {
      permissions.push(permission?.permission_name);
    });
  });

  useEffect(() => {
    if (token?.length) {
      localStorage.setItem("token", token);
      localStorage.setItem("permissions", encryption(permissions));
      localStorage.setItem("roles", encryption(roles));
      history.replace(from);
    }
  }, [token?.length]);

  let [color, setColor] = useState("rgb(54, 215, 183)");
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
  useEffect(() => {
    if (data?.userLogin?.result_code == "002") {
      Swal.fire({
        icon: "error",
        text: `Incorrect username or password.`,
      });
    }
  }, [data?.userLogin?.result_code]);

  // const [recaptchaValue, setRecaptchaValue] = useState(null);

  // const handleRecaptchaChange = (value) => {
  //   console.log("ReCAPTCHA Verified:", value);
  //   setRecaptchaValue(value);
  // };
  return (
    <>
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            <span className="account__logo">
              Office Management
              {/* <span className="account_by"> by</span>
              <span className="account__logo-accent"> iPAGE</span> */}
            </span>
          </h3>
        </div>
        <Form onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            <form className="form login-form" onSubmit={handleSubmit}>
              <div className="form__form-group">
                <span className="form__form-group-label">{fieldUser}</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <AccountOutlineIcon />
                  </div>
                  <Field
                    name="username"
                    component="input"
                    type={typeFieldUser}
                    placeholder={fieldUser}
                    defaultValue={
                      Cookies.get("username")
                        ? decodeData(Cookies.get("username"))
                        : ""
                    }
                    className="input-without-border-radius"
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Password</span>
                <div className="form__form-group-field">
                  <Field
                    name="password"
                    component={PasswordField}
                    placeholder="Password"
                    className="input-without-border-radius"
                    defaultValue={
                      Cookies.get("password")
                        ? decodeData(Cookies.get("password"))
                        : ""
                    }
                    keyIcon
                  />
                  <div className="account__forgot-password">
                    <NavLink to="/reset_password">Forgot a password?</NavLink>
                  </div>
                </div>
              </div>
              {/* <div style={{ minHeight: "80px", marginTop: "10px" }}>
                <ReCAPTCHA
                  className="recaptcha"
                  sitekey="6Lfe1fUqAAAAAD_vuvtAXqKWyGFykGHEy7GINz0N"
                  // sitekey="6Lck1_UqAAAAABcm95FZCFveIlZFpI-lBUGxxMy4"
                  onChange={handleRecaptchaChange}
                />
              </div> */}
              <div className="form__form-group">
                <div className="form__form-group form__form-group-field">
                  <Field
                    name="remember_me"
                    component={renderCheckBoxField}
                    label="Remember me"
                    type="checkbox"
                    defaultValue={
                      Cookies.get("remember_me") === "true" ?? false
                    }
                  />
                </div>
              </div>
              <div className="account__btns">
                {form === "modal_login" ? (
                  loading ? (
                    <Button className="btn btn-primary account__btn ml-1">
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loging...
                    </Button>
                  ) : (
                    <Button
                      // disabled={!recaptchaValue}
                      className="account__btn"
                      type="submit"
                      color="primary"
                    >
                      Sign In
                    </Button>
                  )
                ) : // eslint-disable-next-line space-infix-ops
                loading ? (
                  <Button className="btn btn-primary account__btn ml-1">
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loging...
                  </Button>
                ) : (
                  <Button
                    // disabled={!recaptchaValue}
                    className="account__btn btn btn-primary"
                  >
                    Sign In
                  </Button>
                )}
                {/* <NavLink className="btn btn-outline-primary account__btn" to="/register">Create
            Account
          </NavLink> */}
              </div>
              <a
                href="/cv-portal.html"
                target="_blank"
                rel="noopener noreferrer"
                className=" d-flex align-items-center justify-content-between text-decoration-none"
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  background: "#f8fafc",
                  border: "1px solid #d9dee8",
                  borderRadius: 8,
                  color: "#1f2937",
                  boxShadow: "0 6px 16px rgba(31, 41, 55, 0.08)",
                }}
              >
                <span>
                  <span
                    style={{ display: "block", fontSize: 14, fontWeight: 700 }}
                  >
                    Open CV Portal
                  </span>
                  <span
                    style={{ display: "block", fontSize: 12, color: "#6b7280" }}
                  >
                    Manage profile and download CV
                  </span>
                </span>

                <span
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 6,
                    background: "#2f374d",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                >
                  →
                </span>
              </a>
            </form>
          )}
        </Form>
      </div>
      <ToastContainer />
    </>
  );
};

LogInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  errorMsg: PropTypes.string,
  fieldUser: PropTypes.string,
  typeFieldUser: PropTypes.string,
  form: PropTypes.string.isRequired,
};

LogInForm.defaultProps = {
  errorMessage: "",
  errorMsg: "",
  fieldUser: "Username",
  typeFieldUser: "text",
};

export default connect((state) => ({
  errorMsg: state.user.error,
}))(LogInForm);
